import {Moment} from 'moment'

export function formatDateLocal(datetime: Moment): string {
    return datetime.format('YYYY-MM-DD')
}

export function formatDateLocalSlashSeparator(datetime: Moment): string {
    return datetime.format('YYYY/MM/DD')
}

export function formatTimeLocal(datetime: Moment): string {
    return datetime.format('HH:mm')
}

export function formatDateTimeLocal(datetime: Moment): string {
    return datetime.format('YYYY-MM-DD HH:mm')
}

export function formatDateTimeLocalSlashSeparator(datetime: Moment): string {
    return datetime.format('YYYY/MM/DD HH:mm')
}

export function formatDateWithDayOfTheWeek(datetime: Moment): string {
    return datetime.format('YYYY年M月D日(ddd)')
}

export function formatDatetimeWithDayOfTheWeek(datetime: Moment): string {
    return datetime.format('YYYY年M月D日(ddd) H:mm')
}

export function formatYearAndMonth(datetime: Moment): string {
    return datetime.format('YYYY年M月')
}

export function formatDayOfTheWeek(datetime: Moment): string {
    return datetime.format('ddd')
}

export function formatMonthAndDay(datetime: Moment): string {
    return datetime.format('M/D')
}
